// extracted by mini-css-extract-plugin
export default {"outerWrapper":"src-modules-form-FormContainer-style__outerWrapper_TRVQV","wrapper":"src-modules-form-FormContainer-style__wrapper_yE0mj"};